import {defineMessages} from "react-intl";

const messages = defineMessages({
  editMe: {
    description: "Edit this description",
    defaultMessage: "Edit me!",
    id: "ReactDualRangeSlider.electrodeio.editMe"
  }
});

module.exports = messages;



// WEBPACK FOOTER //
// ./src/lang/tenants/electrodeio/default-messages.js